import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-product-category-lang',
  templateUrl: './product-category-lang.component.html',
  styleUrls: ['./product-category-lang.component.css']
})
export class ProductCategoryLangComponent implements OnInit {
    productCategoryKeyno;

    public inputListLanguages: LanguageItem[] = [];

    public saving = false;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.productCategoryKeyno = this.stateService.getStateParams()['productcategory_keyno'];
    }

    private async loadLanguages() {
        if (!!this.productCategoryKeyno) {
            this.inputListLanguages = await this.datatask.Post(2713, { productcategory_keyno: this.productCategoryKeyno });
        }
    }

    public async saveChanges() {
        if (!!this.inputListLanguages) {
            try {
                this.saving = true;

                await this.datatask.Post(2714, { records: this.inputListLanguages });

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadLanguages();
    }

    ngOnInit() {
        this.init();
    }
}

interface LanguageItem {
    productcategory_keyno: number;
    productcategorylang_name: string;
    language_id: string;
    language_name: string;
    orderby: number;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('productCategoryLang', {
//        templateUrl: 'views/components/views/productCategoryLang/productCategoryLang.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'productCategoryLangService', function ($stateParams, stateService, productCategoryLangService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let productCategoryKeyno = $stateParams.productcategory_keyno;

//            vm.model = {
//                inputListLanguages: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadLanguages() {
//                vm.model.inputListLanguages = await productCategoryLangService.listProductCategoryLanguages({ productcategory_keyno: productCategoryKeyno });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                productCategoryLangService.saveObj({ records: vm.model.inputListLanguages }).then(() => {
//                    vm.model.lockedSave = false;
//                    stateService.back();
//                }, () => vm.model.lockedSave = false);
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadLanguages();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
